export default class CreateEntityWorkTypeAssociationError extends Error {

}